// Firm-wide helper for displaying a client's label consistently.
// Company clients: show company_name, fall back to contact person if blank.
// Individual clients: show "First Last", trimmed.
// Handles null/undefined client + missing fields gracefully.
export function displayClientName(client, opts = {}) {
  if (!client) return opts.fallback || '(no client)'
  const {
    client_type,
    company_name,
    first_name,
    last_name,
  } = client
  const personName = `${first_name || ''} ${last_name || ''}`.trim()
  const company = (company_name || '').trim()
  if (client_type === 'company') {
    return company || personName || opts.fallback || '(unnamed company)'
  }
  return personName || company || opts.fallback || '(unnamed client)'
}

// Sort accessor: uses company_name for companies, last_name for individuals.
export function clientSortKey(client) {
  if (!client) return ''
  if (client.client_type === 'company') {
    return (client.company_name || client.last_name || '').toLowerCase()
  }
  return (client.last_name || client.company_name || '').toLowerCase()
}

// Convenience for the display name derived from raw matter-list row where
// backend inlines first_name/last_name/company_name/client_type.
export function displayClientForMatterRow(matterRow) {
  return displayClientName({
    client_type: matterRow.client_type,
    company_name: matterRow.company_name,
    first_name: matterRow.first_name,
    last_name: matterRow.last_name,
  })
}
